export enum SupersonicFeatureFlags {
    RestrictFromMakingOffer = 'restrict-from-making-offer',
    ShowHomeUnitOnImportQueueDetails = 'show-home-unit-on-import-queue',
    AddBlankRepOptions = 'add-blank-rep-options',
    AddPlacementsPipelineDateField = 'add-placements-pipeline-date-field',
    ShiftStatusDowngradeLogic = 'shift-status-downgrade-logic',
    AddCreditFieldsToFacilityGrid = 'credit-specific-fields-to-facilities-grid',
    TimekeepingDisputeWindows = 'timekeeping-dispute-windows',
    FixDynamicMatchingChipInitialState = 'fix-dynamic-matching-chip-initial-state'
}
